import { combineReducers } from 'redux';
import { authModule } from './user/user.reducer';
import { uiModule } from './ui/ui.reducer';
import { githubModule } from './github/github.reducer';
import { groupsModule } from './groups/groups.reducer';
import { assignmentsModule } from './assignments/assignments.reducer';
import { messageModule } from './message/message.reducer';
import { templateModule } from './template/template.reducer';
import { uploadModule } from './upload/upload.reducer';
import { trainingResultModule } from './trainingResult/trainingResult.reducer';
import { templatesModule } from './templates/templates.reducer';
import { baseLibraryModule } from './baseLibrary/baseLibrary.reducer';
import { groupsClassModule } from './groupsClass/groupsClass.reducer';

const reducers = {
  ui: uiModule.reducer,
  auth: authModule.reducer,
  message: messageModule.reducer,
  github: githubModule.reducer,
  groups: groupsModule.reducer,
  assignments: assignmentsModule.reducer,
  template: templateModule.reducer,
  upload: uploadModule.reducer,
  trainingResult: trainingResultModule.reducer,
  templates: templatesModule.reducer,
  baseLibrary: baseLibraryModule.reducer,
  groupClass: groupsClassModule.reducer,
};

export default combineReducers(reducers);
